export default function customSelect() {
	const select_items = document.querySelectorAll( '.custom-select__selector' );

	select_items.forEach( ( select ) => {
			var current = select.querySelector( '.custom-select__selected' );
			var optionsBox = select.querySelector( '.custom-select__options' );
			if (optionsBox) {
				var options = optionsBox.querySelectorAll( '.custom-select__option' );
				current.addEventListener(
					'click',
					function( e ) {
						optionsBox.classList.toggle( 'd-none' );
						if (!optionsBox.classList.contains( 'd-none' )) {
							current.classList.add( 'active' );
						}
					},
				);

				options.forEach(
					function( option ) {
						option.addEventListener(
							'click',
							function( e ) {
								current.dataset.value = option.dataset.value;
								current.innerHTML = option.innerHTML;
								optionsBox.classList.add( 'd-none' );
								current.classList.remove( 'active' );
							},
						);
					},
				);

				document.addEventListener(
					'click',
					function( e ) {
						if (e.target !== select && e.target.parentElement !== select) {
							optionsBox.classList.add( 'd-none' );
							current.classList.remove( 'active' );
						}
					},
				);
			}
		},
	);

}
